// Updated Header.js - Minimalistic: Clean nav, subtle hover, simplified mobile menu
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const toggleMenu = () => setIsOpen(!isOpen);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/programs', label: 'Programs' },
    { to: '/impact', label: 'Impact' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <header className="bg-ehh-cream text-ehh-navy shadow-sm sticky top-0 z-50">
      <nav className="container mx-auto flex justify-between items-center py-4 px-6">
        <Link to="/" className="flex items-center gap-2 text-2xl font-semibold">
          <img src="/logo.png" alt="EHH Logo" className="h-8" />
          EMA House of Hope
        </Link>
        <ul className="hidden md:flex items-center space-x-6">
          {navLinks.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                className={`text-base transition ${isActive(link.to) ? 'text-ehh-orange font-medium' : 'hover:text-ehh-orange'}`}
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li>
            <Link
              to="/donate"
              className="bg-ehh-orange text-ehh-cream px-4 py-2 rounded-md text-base font-medium hover:bg-ehh-coral transition"
            >
              Donate
            </Link>
          </li>
        </ul>
        <button onClick={toggleMenu} className="md:hidden text-ehh-navy focus:outline-none">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </nav>
      {isOpen && (
        <div className="md:hidden bg-ehh-cream py-4 px-6">
          <ul className="flex flex-col space-y-4">
            {navLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} onClick={toggleMenu} className="text-base hover:text-ehh-orange">
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/donate" onClick={toggleMenu} className="bg-ehh-orange text-ehh-cream px-4 py-2 rounded-md text-base font-medium">
                Donate
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;